import Button from '@shared/components/core/button/CoreButton';
import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export default function ProjectEmptyBanner() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <PageBannerCard
            description={t('common:organization.projects.create.first.description')}
            fullHeight
            title={t('common:organization.projects.create.first.title')}>
            <Button onClick={() => navigate('new')} startIcon="plusLight">
                {t('common:organization.projects.create.title')}
            </Button>
        </PageBannerCard>
    );
}
